// The one destructive door in the menu, asked in the game's own voice.
//
// It was a `window.confirm`, which is the browser's chrome rather than the
// game's: an unstyled box at the top of the window, in the system font, that
// says the page's hostname above the sentence. It also *blocks the main thread*
// — the render loop stops and the board behind it freezes — and it cannot be
// driven, so no smoke could ever cover the destructive path.
//
// Cancel is the default action and Start over is the one you have to reach for
// — the opposite of a browser confirm, where OK has the focus and Enter
// destroys the save. It says what is actually being thrown away, which "your
// saved run will be lost" did not: how far in it was.

import { Btn, Modal, ModalActions, ModalBody, ModalTitle, Text } from "../kit";

export function DiscardDialog({
  open,
  onClose,
  onConfirm,
  save
}: {
  open: boolean;
  onClose(): void;
  onConfirm(): void;
  save: { level: string; plies: number } | null;
}) {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="discard-run-title">
      <ModalTitle id="discard-run-title">Start over?</ModalTitle>
      <ModalBody>
        <Text tone="dim" size={13.5} block style={{ lineHeight: 1.55, maxWidth: "46ch" }}>
          {save
            ? `Your run — ${save.level}, ${save.plies} ${save.plies === 1 ? "ply" : "plies"} in — is the only copy, and starting a new one replaces it.`
            : "Your saved run is the only copy, and starting a new one replaces it."}
        </Text>
      </ModalBody>
      <ModalActions>
        <Btn variant="ghost" data-testid="discard-cancel" autoFocus onClick={onClose}>
          Keep it
        </Btn>
        <Btn variant="danger" data-testid="discard-confirm" onClick={onConfirm}>
          Start over
        </Btn>
      </ModalActions>
    </Modal>
  );
}
